// src/context/alert/AlertContext.js
import { createContext } from 'react';

export const AlertContext = createContext();